import { OrderItemReturnPolicy } from '../../constants';
import { useCart } from './useCart';
import { LineItem } from './cart.rest';

export const isLineItemAvailableNow = (lineItem: LineItem) =>
  lineItem.attributes.isProductAvailable &&
  !lineItem.attributes.error &&
  lineItem.attributes.isAvailableNow;

export const useCartItems = () => {
  const { cart } = useCart();
  const cartItems = cart.attributes.cartItems.map(item => item.data);

  const availableNowItems = cartItems.filter(isLineItemAvailableNow);

  const preorderItems = cartItems.filter(
    item =>
      item.attributes.isProductAvailable &&
      !item.attributes.error &&
      !item.attributes.isAvailableNow
  );

  const unavailableItems = cartItems.filter(
    item => !item.attributes.isProductAvailable || item.attributes.error
  );

  const personalizationRequiredItems = cartItems.filter(
    item => item.attributes.error?.type === 'PERSONALIZATION_ERROR'
  );

  const returnPolicyChangedItems = cartItems.filter(
    item =>
      item.attributes.returnPolicy &&
      item.attributes.returnPolicyCode === OrderItemReturnPolicy.FullRefundPromo &&
      item.attributes.promotionApplicableMessage &&
      cart.attributes.giftCode
  );

  const canProceedToCheckout =
    unavailableItems.length > 0 || personalizationRequiredItems.length > 0;

  return {
    cartItems,
    availableNowItems,
    preorderItems,
    unavailableItems,
    personalizationRequiredItems,
    returnPolicyChangedItems,
    canProceedToCheckout
  };
};
